// extracted by mini-css-extract-plugin
export default {"tooltip":"LTooltip_tooltip__EeNDz","tooltipText":"LTooltip_tooltipText__gopLm","up":"LTooltip_up__-ZImB","down":"LTooltip_down__EGeA+","downRight":"LTooltip_downRight__GMhcn"};